import { render, staticRenderFns } from "./resumenVentasPeriodo.vue?vue&type=template&id=75781326"
import script from "./resumenVentasPeriodo.vue?vue&type=script&lang=js"
export * from "./resumenVentasPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports